import ComponentBase from "@components/ComponentBase";
import { ComponentElem } from "@components/interfaces";
import Field from "./inputs/Field";
import { Common } from "../common/CommonTypes";
import gsap from "gsap";

export default class CollapseWrapper extends ComponentBase
{
  _isCollapsed: boolean = false;

  _needUpdateFieldsHidden: boolean;

  constructor(elem: ComponentElem, needUpdateFieldsHidden: boolean = true)
  {
    super(elem);

    this._needUpdateFieldsHidden = needUpdateFieldsHidden;

    this._isCollapsed = this.$root.attr("collapsed") === "true";

    let relatedId = this.$root.attr("relate");    

    if (relatedId) {
      let openAtValue = this.$root.attr("open-at-value"),
        component: Common.CollapseRelational = (<ComponentElem>$(`#${relatedId}`)[0])._component;

      if (!component) throw new Error(`relate element id: [${relatedId}] is not exist`);

      component.emitter.on("change", (value: string) =>
      {
        let isOpen = value === openAtValue;
        this.toggle(!isOpen);
      });

    }

    this._update();
  }

  toggle(on?: boolean)
  {
    if (on === undefined) on = !this._isCollapsed;
    this._isCollapsed = on;
    this._update();
  }

  _update()
  {

    if(this.$root.attr("tween") === "false")
    {
      this.$root.attr("collapsed", this._isCollapsed ? "true" : "false");
    }
    else
    {
      let $content = this.$root.find(".wrapper-for-content");
      
      let contentHeight = $content.height();    
      
      let currentHeight = this.$root.height();

      // console.log(`content height: ${contentHeight}, current height: ${currentHeight}`);  
  
      let maxHeight = this._isCollapsed ? 0 : contentHeight;
  
      gsap.killTweensOf(this.$root[0]);
      gsap.set(this.$root[0], {height: currentHeight});
      gsap.to(this.$root[0], {
        height: maxHeight,
        onComplete: ()=>
        {
          gsap.set(this.$root[0], {clearProps:"all"});
          // this.$root.attr("style", "");
        }
      });
      
      // 此行必須在 gsap 更換 style 內容之後, 不然會提前改變內容高度導致捲動位置變動
      this.$root.attr("collapsed", this._isCollapsed ? "true" : "false");
    }

    if(this._needUpdateFieldsHidden) this.updateFieldsHidden(this._isCollapsed);
  }

  updateFieldsHidden(ancestorIsCollapsed: boolean)
  {
    let $fields = this.$root.find(`[component="field"]`);
    (this._isCollapsed || ancestorIsCollapsed) ? $fields.attr("collapsed", "true") : $fields.removeAttr("collapsed");

    let list = this.$root.find(`[component="collapse-wrapper"]`).toArray();
    list.forEach((elem: ComponentElem) =>
    {
      if (elem._component) elem._component.updateFieldsHidden(ancestorIsCollapsed);
    });
  }
}

